import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetGeoLocation = async (rId, type) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `geolocations?rootId=${rId}&type=${type}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}